

import RequestAbstract from "../abstract";

export default class WalletNotifications extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/wallet/notifications";
    }
}

